var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157351"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2125",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M7.539 7.5L13.7267 15.7734L7.5 22.5H8.90148L14.353 16.6106L18.7576 22.5H23.5266L16.9906 13.7614L22.7864 7.5H21.3849L16.3645 12.9239L12.308 7.5H7.539ZM9.59994 8.53222H11.7908L21.4654 21.4678H19.2745L9.59994 8.53222Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitterLogo.b234d283d18a335c8673aae568285171.svg";
export { ForwardRef as ReactComponent };